import { saveWidgetPlacements } from './StateFrames';
export class WidgetPlacementManager {
    widgets;
    setWidgets;
    constructor(widgets, setWidgets) {
        this.widgets = widgets;
        this.setWidgets = setWidgets;
    }
    getWidgets(widgets, placementType, placeholderName) {
        const result = [];
        function matchPlaceholderName(placement) {
            if (!placeholderName) {
                return true;
            }
            return placement.placeholderName === placeholderName;
        }
        for (const widget of widgets) {
            if (widget.placement) {
                if (widget.placement.type === placementType &&
                    matchPlaceholderName(widget.placement)) {
                    result.push([widget, widget.placement]);
                }
            }
            else if (widget.defaultPlacement &&
                widget.defaultPlacement.type === placementType &&
                matchPlaceholderName(widget.defaultPlacement)) {
                result.push([widget, widget.defaultPlacement]);
            }
        }
        return result;
    }
    doUpdate() {
        saveWidgetPlacements(this.widgets);
        if (this.setWidgets) {
            this.setWidgets([...this.widgets]);
        }
    }
}
